<div #input class="jit-calendar-input" (click)="onToggle($event)">
  <div class="jit-calendar-input__value">
    @if (value) {
      {{ value.toFormat('LL/dd/yy') }}
    } @else {
      {{ placeholder }}
    }
  </div>
  <div class="jit-calendar-input__icon">
    <jit-icon-simple iconId="calendar"></jit-icon-simple>
    @if (clearable && value) {
      <div class="jit-calendar-input__clear" (click)="onClear($event)">
        <jit-icon-simple iconId="x-outline"></jit-icon-simple>
      </div>
    }
  </div>
  <div
    #popup
    class="jit-calendar-input__popup"
    [class.is-open]="isOpen"
    [style]="listStyle"
  >
    <jit-calendar-list
      #list
      [value]="value"
      [month]="value ? value.month : undefined"
      [year]="value ? value.year : undefined"
      [sundayFirst]="true"
      [canSelectPast]="canSelectPast"
      [rangeEndDate]="rangeEndDate"
      [alwaysShowToday]="alwaysShowToday"
      (change)="onChange($event)"
    ></jit-calendar-list>
  </div>
</div>
